import React, { createContext, useContext, useState, useEffect } from 'react';

// Create ThemeContext
const ThemeContext = createContext({
    isDarkMode: false,
    toggleTheme: () => {},
});

// Custom Hook
export const useTheme = () => {
    return useContext(ThemeContext);
};

// ThemeProvider component to wrap the application
export const ThemeProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const savedIsLightMode = localStorage.getItem("isLightMode");
        return savedIsLightMode ? savedIsLightMode === "false" : false;
    });

    const toggleTheme = () => {
        setIsDarkMode((prevMode) => !prevMode);
    };

    useEffect(() => {
        localStorage.setItem("isLightMode", String(!isDarkMode));
    }, [isDarkMode]);

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
